<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1">
<p class="half">The French at Waterloo: Eyewitness Accounts</p>
</a><a id="VPS-2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Halftitle.vue?31e7911e